module.exports = __webpack_public_path__ + "static/media/man-min.22516b1f.png";